<template>
  <div class="bubble-box sc-message--contact" v-ripple role="button" v-on:click="clicked" :id="mid">

     <v-layout align-center style="padding:5px;">
      <span style="margin-right: 8px; margin-left:-4px;">
        <user-avatar 
          :avatar="avatar"
          :username="contact.name" 
          :size="40"
        />
      </span>

      <span class="sc-message--contact-title">{{contact.name}}</span>
    </v-layout>

    <MessageState :state="state" :time="time" />

  </div>
</template>

<script>
  import UserAvatar from '@common/UserAvatar.vue'
  import MessageState from './MessageState.vue'

  export default {
    data: () => ({
      avatar: '',
    }),
    components: { 
      MessageState,
      UserAvatar
    },
    props: {
      contact: {
        type: Object,
        required: true
      },
      state: Number,
      time: String,
      mid: Number
    },
    mounted() {
      let item = this.$store.state.contacts.find(c => c.contactId == this.contact.id)
      this.avatar = (item) ? item.avatar : ''
    },
    methods:{
      clicked(e) {
        // to fix auto close of contact dialog
        e.stopPropagation()

        let item = this.$store.state.contacts.find(c => c.contactId == this.contact.id)
        if (item) {
          this.$store.dispatch('openContactDetails', this.contact.id)
        } else {
          this.$store.dispatch('showAddContact', this.contact.id)
        }
      }
    }
  }
</script>

<style>
  .sc-message--contact {
    min-width:108px;
    user-select: none;
  }
  .sc-message--contact:hover {
    /*background-color: var(--v-secondary-lighten2);*/
    opacity:0.8;
    border-radius:inherit;
  }
  .sc-message--contact-title {
    font-weight: inherit;/*bold;*/
  }
</style>
